import React from "react";
import { ShieldCheck, BadgeCheck, ClipboardList, UserCheck, Wrench } from "lucide-react";

const PILLARS = [
  { icon: ShieldCheck, title: "Manejo seguro de gases", desc: "Protocolos certificados de transporte, almacenamiento y entrega." },
  { icon: BadgeCheck, title: "Calidad certificada", desc: "Gases con pureza verificada y equipos avalados por proveedores líderes." },
  { icon: ClipboardList, title: "Protocolos de seguridad", desc: "Procedimientos documentados para cada tipo de gas y aplicación." },
  { icon: UserCheck, title: "Atención profesional", desc: "Personal capacitado para asesorarte y entregar con responsabilidad." },
  { icon: Wrench, title: "Equipos confiables", desc: "Reguladores, válvulas y accesorios revisados antes de cada entrega." },
];

const SAFETY_IMG =
  "https://images.unsplash.com/photo-1762786219193-f34607f29d38?auto=format&fit=crop&w=1200&q=80";

export default function Safety() {
  return (
    <section
      id="seguridad"
      data-testid="safety-section"
      className="relative py-20 lg:py-28 bg-[var(--cima-navy)] text-white overflow-hidden"
    >
      {/* Diagonal accent */}
      <div className="absolute top-0 left-0 w-full h-1 stripe-accent opacity-80" />
      <div className="absolute -bottom-10 -left-10 w-44 h-44 stripe-accent opacity-30 -rotate-12" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          {/* Image */}
          <div className="lg:col-span-5 order-2 lg:order-1">
            <div className="relative">
              <div className="border border-white/20 p-3">
                <div className="aspect-[4/5] bg-cover bg-center grain-overlay" style={{ backgroundImage: `url(${SAFETY_IMG})` }} />
              </div>
              <div className="absolute -bottom-5 -right-5 bg-[var(--cima-red)] px-5 py-4 max-w-[260px] shadow-2xl">
                <div className="text-[10px] font-mono-cima uppercase tracking-widest text-white/80">
                  Compromiso CIMA
                </div>
                <div className="font-display font-bold text-lg leading-tight mt-1 text-white">
                  Seguridad antes que nada.
                </div>
              </div>
            </div>
          </div>

          {/* Pillars */}
          <div className="lg:col-span-7 order-1 lg:order-2">
            <span className="divider-orange mb-5" />
            <p className="font-mono-cima text-xs uppercase tracking-widest text-[var(--cima-orange-soft)] mb-3">
              Seguridad Industrial
            </p>
            <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl leading-tight">
              Manejo responsable, <br className="hidden sm:block" />
              entrega confiable.
            </h2>
            <p className="mt-5 text-white/80 max-w-2xl leading-relaxed">
              Cada cilindro, cada conexión y cada entrega siguen estrictos estándares de seguridad. Así
              protegemos a tu equipo, tus instalaciones y a quienes dependen de un suministro continuo.
            </p>

            <div className="mt-10 grid sm:grid-cols-2 gap-px bg-white/10">
              {PILLARS.map((p, i) => (
                <div
                  key={p.title}
                  data-testid={`safety-pillar-${i}`}
                  className="bg-[var(--cima-navy)] p-6 hover:bg-[var(--cima-navy-soft)] transition-colors"
                >
                  <p.icon className="w-6 h-6 text-[var(--cima-orange-soft)] mb-3" />
                  <h3 className="font-display font-semibold text-lg text-white">{p.title}</h3>
                  <p className="text-sm text-white/70 mt-1.5">{p.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
